export enum ReadingDataType{
    Decimal = 1,
    Integer = 2,
    Text = 3,
    TAG = 4,
}
